// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   FELUGRÓ ABLAKOK (DialogModals)
   ========================================= */

/* --- 1. CUSTOM ALERT MODAL (Rendszerüzenetek, pl. Mentés sikeres) --- */
.szakjelentes-create-wrapper .custom-alert-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.szakjelentes-create-wrapper .custom-alert-modal {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    outline: none;
    max-width: 400px;
    width: 90%;
    pointer-events: auto;
    z-index: 1001;
}

.szakjelentes-create-wrapper .custom-alert-content {
    text-align: center;
}

.szakjelentes-create-wrapper .custom-alert-message {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
}

.szakjelentes-create-wrapper .custom-alert-button {
    padding: 10px 20px;
    background-color: #44ACC9;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
}

.szakjelentes-create-wrapper .custom-alert-button:hover {
    background-color: #357a9d;
}

/* --- 2. CONFIRMATION MODAL (Megerősítő kérdések, pl. Biztosan lezárja?) --- */
.szakjelentes-create-wrapper .confirmation-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.szakjelentes-create-wrapper .confirmation-modal {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    outline: none;
    max-width: 400px;
    width: 90%;
    pointer-events: auto;
    z-index: 1001;
}

.szakjelentes-create-wrapper .confirmation-modal-content {
    text-align: center;
}

.szakjelentes-create-wrapper .confirmation-modal-message {
    margin-bottom: 30px;
    font-size: 18px;
    font-weight: bold;
    color: #333;
}

.szakjelentes-create-wrapper .confirmation-modal-error {
    color: #b42318;
    margin-bottom: 15px;
}

.szakjelentes-create-wrapper .confirmation-modal-buttons {
    display: flex;
    gap: 15px;
    justify-content: center;
}

.szakjelentes-create-wrapper .confirmation-button-cancel {
    padding: 10px 30px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
    min-width: 120px;
}

.szakjelentes-create-wrapper .confirmation-button-cancel:hover {
    background-color: #a02834;
}

.szakjelentes-create-wrapper .confirmation-button-confirm {
    padding: 10px 30px;
    background-color: #44ACC9;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
    min-width: 120px;
}

.szakjelentes-create-wrapper .confirmation-button-confirm:hover {
    background-color: #357a9d;
}

/* --- MODAL OPEN ÁLLAPOT KEZELÉSE --- */
body.modal-open .szakjelentes-create-wrapper .details-container,
body.modal-open .szakjelentes-create-wrapper .side-tile {
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/szakjelentesCreate/DialogModals.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C,yEAAyE;AACzE;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,+EAA+E;AAC/E;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wCAAwC;AACxC;;IAEI,oBAAoB;AACxB","sourcesContent":["/* =========================================\n   FELUGRÓ ABLAKOK (DialogModals)\n   ========================================= */\n\n/* --- 1. CUSTOM ALERT MODAL (Rendszerüzenetek, pl. Mentés sikeres) --- */\n.szakjelentes-create-wrapper .custom-alert-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.szakjelentes-create-wrapper .custom-alert-modal {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    outline: none;\n    max-width: 400px;\n    width: 90%;\n    pointer-events: auto;\n    z-index: 1001;\n}\n\n.szakjelentes-create-wrapper .custom-alert-content {\n    text-align: center;\n}\n\n.szakjelentes-create-wrapper .custom-alert-message {\n    margin-bottom: 20px;\n    font-size: 24px;\n    font-weight: bold;\n    color: #333;\n}\n\n.szakjelentes-create-wrapper .custom-alert-button {\n    padding: 10px 20px;\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n}\n\n.szakjelentes-create-wrapper .custom-alert-button:hover {\n    background-color: #357a9d;\n}\n\n/* --- 2. CONFIRMATION MODAL (Megerősítő kérdések, pl. Biztosan lezárja?) --- */\n.szakjelentes-create-wrapper .confirmation-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.szakjelentes-create-wrapper .confirmation-modal {\n    background: white;\n    padding: 30px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    outline: none;\n    max-width: 400px;\n    width: 90%;\n    pointer-events: auto;\n    z-index: 1001;\n}\n\n.szakjelentes-create-wrapper .confirmation-modal-content {\n    text-align: center;\n}\n\n.szakjelentes-create-wrapper .confirmation-modal-message {\n    margin-bottom: 30px;\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n}\n\n.szakjelentes-create-wrapper .confirmation-modal-error {\n    color: #b42318;\n    margin-bottom: 15px;\n}\n\n.szakjelentes-create-wrapper .confirmation-modal-buttons {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n}\n\n.szakjelentes-create-wrapper .confirmation-button-cancel {\n    padding: 10px 30px;\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n    min-width: 120px;\n}\n\n.szakjelentes-create-wrapper .confirmation-button-cancel:hover {\n    background-color: #a02834;\n}\n\n.szakjelentes-create-wrapper .confirmation-button-confirm {\n    padding: 10px 30px;\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n    min-width: 120px;\n}\n\n.szakjelentes-create-wrapper .confirmation-button-confirm:hover {\n    background-color: #357a9d;\n}\n\n/* --- MODAL OPEN ÁLLAPOT KEZELÉSE --- */\nbody.modal-open .szakjelentes-create-wrapper .details-container,\nbody.modal-open .szakjelentes-create-wrapper .side-tile {\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
